import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "warehouse-information"
}
const _hoisted_2 = {
  class: "row items-center q-mb-md",
  style: {"margin":"1rem 0 1.6rem"}
}
const _hoisted_3 = { class: "row items-center q-mb-md" }
const _hoisted_4 = {
  key: 1,
  class: "subtitle break"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "active-warehouse"
}
const _hoisted_7 = { class: "warehouse" }
const _hoisted_8 = { class: "location" }
const _hoisted_9 = { class: "row q-mb-md items-center" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "label--value q-mr-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_ctx.warehouses && _ctx.locations)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider warehouse" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "bold card-title q-mr-sm" }, "Total Stock", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.stockCount) + " ", 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "card-title q-mr-sm" }, "In warehouse", -1)),
          (Object.keys(_ctx.componentLocations).length !== 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activeWarehouse, (value, key) => {
                return (_openBlock(), _createElementBlock("h5", {
                  class: _normalizeClass(["card-title underline q-mr-sm active-warehouse", { expanded: _ctx.expanded }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                }, [
                  _createElementVNode("span", null, _toDisplayString(key) + " ", 1),
                  _createVNode(_component_chevron_down_icon, {
                    class: _normalizeClass({ expanded: _ctx.expanded })
                  }, null, 8, ["class"])
                ], 2))
              }), 256))
            : (_openBlock(), _createElementBlock("h6", _hoisted_4, "No locations found")),
          (_ctx.expanded)
            ? (_openBlock(), _createBlock(_component_q_menu, {
                key: 2,
                class: "warehouse-menu",
                offset: [-10,0]
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentLocations, (value, key) => {
                    return (_openBlock(), _createElementBlock("h5", {
                      class: "warehouse-option card-title",
                      onClick: ($event: any) => (_ctx.setActiveWarehouse(key))
                    }, _toDisplayString(key), 9, _hoisted_5))
                  }), 256))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.activeWarehouse)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeWarehouse, (value, key) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (location) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(location.id), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(location.count), 1)
                      ])
                    ]))
                  }), 256))
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}